import React, { FC } from "react"

export const ShowIf: FC<{ condition: boolean }> = ({ condition, children }) =>
  condition ? <>{children}</> : null
